/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './tooltip';
import './tooltip-body';
import './tooltip-definition';
import './tooltip-footer';
import './tooltip-icon';
